import { styled } from "@mui/material/styles";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { CssDataJacketTitleTypography } from "../../styles/styled";
import { NewNetWorkPage } from "./newDataNetwork";
import NetworkMap from "./dataNetworkMap";
import HomeBar from "../../HomeBar";
import Footer from "../../Footer";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  textAlign: "center",
  color: theme.palette.text.secondary,
  boxShadow: "none",
}));

const CssBox = styled(Box)({
  overflowY: "scroll",
  scrollbarWidth: "thin",
  backgroundColor: "#171717",
  color: "white",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  height: "auto",
  maxHeight: "90%",
  bgcolor: "43B02A",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
});

const CssButton = styled(Button)({
  marginTop: "8px",
  display: "block",
  position: "absolute",
  right: 16,
  width: "5px",
  height: "35px",
  backgroundColor: "grey",
});

const CssModal = styled(Modal)({
  maxWidth: "1800px",
  marginLeft: "auto",
  marginRight: "auto",
});

export function SelectDataModalItem() {
  const [open, setOpen] = React.useState(true);
  const [rawData, setRawData] = React.useState([]);
  const [network, setNetwork] = React.useState(false);
  const [mode, setMode] = React.useState("");
  const params = useLocation();
  const navigate = useNavigate();
  const [networkData, setNetworkData] = React.useState([]);
  const [foldNode, setFoldNode] = React.useState([]);
  const [firstLoad, setFirstLoad] = React.useState(false);
  const [tempFlg, setTempFlg] = React.useState(false);
  const [id, setId] = React.useState("");
  const [name, setName] = React.useState("");
  const [summary, setSummary] = React.useState("");
  const [networkDataStorage, setNetworkDataStorage] = React.useState([]);
  const initialCheckboxStates = {
    checkbox1: "type1",
    checkbox2: "type2",
    checkbox3: "type3",
    checkbox4: "type4",
    checkbox5: "type5",
  };

  const [visibleEdgeTypes, setVisibleEdgeTypes] = React.useState(
    initialCheckboxStates
  );
  const [continuousSaving, setContinuousSaving] = React.useState(false);
  const [savedId, setSavedId] = React.useState("");

  function removeElementsByClass(className, length) {
    const elements = document.getElementsByClassName(className);
    while (elements.length > length) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  }

  const handleCancel = () => {
    setOpen(false);
    setMode("cancel");
    if (rawData.length > 0 || params.state !== null) {
      setNetwork(true);
    } else {
      _navigateToPage();
      removeElementsByClass("cytoscape-navigator", 0);
    }
  };
  const handleClose = (inData) => {
    setOpen(false);
    setNetwork(true);
    setRawData(inData);
    setMode("createnew");
  };
  function _navigateToPage() {
    navigate("/datalist");
  }

  React.useEffect(() => {
    if (params.state !== null && params.state.mode !== undefined) {
      setMode(params.state.mode);
      if (params.state.rawData !== undefined) {
        setRawData(params.state.rawData);
      }
    }
    if (params.state !== null && params.state.flag !== undefined) {
      setId(params.state.connectid);
      setTempFlg(true);
      setFirstLoad(true);
      setMode("redirect");
      setNetworkData(JSON.parse(params.state.resultFiltered).networkData);
      setNetworkDataStorage(JSON.parse(params.state.resultAll));
      setFoldNode(JSON.parse(params.state.resultFiltered).foldData);
      setVisibleEdgeTypes(JSON.parse(params.state.resultSimilarity));
      setName(params.state.connectname);
      setSummary(params.state.connectsummary);
    }
  }, []);

  React.useEffect(() => {
    if (mode === "redirect") {
      setOpen(false);
      setNetwork(true);
    } else if (mode === "createnew") {
      setId("");
      handleClose(rawData);
    } else if (mode === "saved") {
      setOpen(false);
    } else if (mode !== "cancel") {
      setOpen(true);
    }
  }, [mode]);

  function renderDisplay() {
    return (
      <NewNetWorkPage
        handleCloseModal={handleClose}
        setTempFlg={setTempFlg}
        tempFlg={tempFlg}
        setContinuousSaving={setContinuousSaving}
        continuousSaving={continuousSaving}
        setSavedId={setSavedId}
        savedId={savedId}
      />
    );
  }

  return (
    <React.Fragment>
      <HomeBar setOpen={setOpen} setDisplay={setNetwork} />
      <NetworkMap
        newFlag={open}
        setNew={setOpen}
        displayFlag={network}
        setDisplay={setNetwork}
        mode={mode}
        setMode={setMode}
        arrNetworkData={rawData}
        setNetworkData={setNetworkData}
        setFoldNode={setFoldNode}
        networkData={networkData}
        setNetworkDataStorage={setNetworkDataStorage}
        networkDataStorage={networkDataStorage}
        foldNode={foldNode}
        setFirstLoad={setFirstLoad}
        firstLoad={firstLoad}
        setTempFlg={setTempFlg}
        tempFlg={tempFlg}
        id={id}
        setRawData={setRawData}
        setName={setName}
        setSummary={setSummary}
        name={name}
        summary={summary}
        visibleEdgeTypes={visibleEdgeTypes}
        setVisibleEdgeTypes={setVisibleEdgeTypes}
        setContinuousSaving={setContinuousSaving}
        continuousSaving={continuousSaving}
        setSavedId={setSavedId}
        savedId={savedId}
      />
      <CssModal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <CssBox
          style={{
            width: "70%",
            height: "900px",
            overflow: "hidden",
            backgroundColor: "#303234",
          }}
        >
          <Box style={{ height: "50px", backgroundColor: "#373737" }}>
            <Stack direction="row" spacing={2}>
              <Item>
                <CssDataJacketTitleTypography style={{ marginLeft: "32px" }}>
                  データネットワーク図
                </CssDataJacketTitleTypography>
              </Item>
              <Item>
                <CssButton onClick={handleCancel}>
                  <CloseIcon style={{ color: "white" }} />
                </CssButton>
              </Item>
            </Stack>
          </Box>
          <Box
            sx={{
              position: "relative",
              display: "inherit",
              backgroundColor: "#303234",
              marginLeft: "-16px",
            }}
          >
            <Box
              style={{
                overflow: "auto",
                height: "700px",
              }}
            >
              {renderDisplay()}
            </Box>
          </Box>
        </CssBox>
      </CssModal>
      <Footer fixed={true} />
    </React.Fragment>
  );
}
